import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/collaboratori',
            name: 'collaboratori',
            component: () => import("./views/collaboratori.vue"),
            meta: {
                hasBar: true
            }
        },
        {
            path: '/collaboratori/:identifier',
            name: 'collaboratoriDetail',
            component: () => import("./views/collaboratoriDetail.vue"),
            meta: {
                hasBar: false
            }
        },
        {
            path: '/collaboratori/:identifier/contatti',
            name: 'contattiDetail',
            component: () => import("./views/contattiDetail.vue"),
            meta: {
                hasBar: false
            }
        },
    ];
};